module.exports = __webpack_public_path__ + "static/img/section4_content2_Bg2.6d7c0403.png";